import * as React from 'react';
import DataTable from './DataTable';
import Box from '@mui/material/Box';

function ShopBarbers() {
  return (
    <Box sx={{ position: 'relative' }}>
      <DataTable />
    </Box>
  );
}

export default ShopBarbers;
